import { useSearch } from "@tanstack/react-router";
import { useContext, useEffect, useState } from "react";
import { useGetEntityDemoLoginParams2 } from "src/services/demo/queries/entities";
import { useGetEntityLoginParams2 } from "src/services/link/queries/entities";
import { isValidToken } from "src/utils/jwt";

import { ConnectAccountParams } from "../../Products/ConnectAccount/ConnectAccount";
import Context from "../../Products/context";
import { useMutateStartFlow } from "../../Products/services/useMutateStartFlow";

type Props = {
	id: string;
	entity: string;
	isDemo?: boolean;
	isUpdateFlow?: boolean;
};

export default function useGetEntityLoginParams({ id, entity, isDemo }: Props) {
	const { state } = useContext(Context);
	const [selectedValue, setSelectValue] = useState("");

	const { locale, externalId }: ConnectAccountParams = useSearch({
		strict: false
	});

	const { startFlow } = useMutateStartFlow();

	const lang = locale === "es_ES" ? "es" : "en";

	const { data, isFetching } = isDemo
		? useGetEntityDemoLoginParams2(entity, id, lang)
		: useGetEntityLoginParams2(entity, state.authToken, lang);

	useEffect(() => {
		const selector = data.find((i) => i.type === "select" || i.type === "radio");
		if (data.length > 0 && !!selector && selector?.options.length > 0) {
			setSelectValue(selector.options[0].value);
		}
	}, [data]);

	useEffect(() => {
		if (state.authToken && !isValidToken(state.authToken)) {
			startFlow(externalId);
		}
	}, [state.authToken]);

	return {
		params: data,
		isLoading: isFetching,
		selectedValue,
		onChangeValue: setSelectValue
	};
}
